import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import VersionSetting from './components/versionSetting/versionSetting';
import { MdOutlineSecurityUpdate, MdConstruction, MdOutlineCleaningServices } from "react-icons/md";
import { HiMiniChatBubbleBottomCenterText } from "react-icons/hi2";
import { SiChatbot } from "react-icons/si";
import Aichatusersetting from './components/aichatSetting/usermessage';
import FreeUserChatLimit from './components/freeUserChatLimit/freeUserChatLimit';
import OpenApplicationMaintenance from './components/openApplicationMaintenance/OpenApplicationMaintenance';
import ClearThreadMessageLimit from './components/clearThreadMessageLimit/ClearThreadMessageLimit';

const Setting = () => {
  const [type, setType] = useState('version-setting');
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Ove | Admin setting</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="admin-wrapper">

            <div className="page-header">
              <div className="col">
                <h1 className="page-title">Setting</h1>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3 col-12">
                <div className="list-group setting-sidebar">
                  <button
                    type="button"
                    className={`list-group-item list-group-item-action ${type === 'version-setting' ? 'active' : ''}`}
                    onClick={() => setType('version-setting')}
                  >
                    <MdOutlineSecurityUpdate className="me-2" />
                    Version Setting
                  </button>

                  <button
                    type="button"
                    className={`list-group-item list-group-item-action ${type === 'ai-prompts' ? 'active' : ''}`}
                    onClick={() => setType('ai-prompts')}
                  >
                    <SiChatbot className="me-2" />
                    AI Prompts
                  </button>

                  <button
                    type="button"
                    className={`list-group-item list-group-item-action ${type === 'chat-limit' ? 'active' : ''}`}
                    onClick={() => setType('chat-limit')}
                  >
                    <HiMiniChatBubbleBottomCenterText className="me-2" />
                    Free User Chat Limit
                  </button>

                  <button
                    type="button"
                    className={`list-group-item list-group-item-action ${type === 'app-maintenance' ? 'active' : ''}`}
                    onClick={() => setType('app-maintenance')}
                  >
                    <MdConstruction className="me-2" />
                    Application Maintenance
                  </button>

                  <button
                    type="button"
                    className={`list-group-item list-group-item-action ${type === 'clear-message-limit' ? 'active' : ''}`}
                    onClick={() => setType('clear-message-limit')}
                  >
                    <MdOutlineCleaningServices className="me-2" />
                    Clear Thread Message Limit
                  </button>
                </div>
              </div>

              {/* Right Content Area */}
              <div className="col-md-9 col-12">
                <div className="setting-content-container">
                  {type === 'version-setting' && <VersionSetting />}
                  {type === 'ai-prompts' && <Aichatusersetting />}
                  {type === 'chat-limit' && <FreeUserChatLimit />}
                  {type === 'app-maintenance' && <OpenApplicationMaintenance />}
                  {type === 'clear-message-limit' && <ClearThreadMessageLimit />}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Setting;
